var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"folders"},[_c('folders-list',{on:{"clickMenu":function (payload) { return _vm.$parent.$emit('clickMenu', payload); }}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }